// Section for import npm components -----------------------------------------------------------------------------------
import React from 'react';
import { createRoot } from 'react-dom/client';
import parse from 'html-react-parser';

// Material UI ( mui )  components
import Box from '@mui/material/Box';

// Section for import custom components --------------------------------------------------------------------------------
import Header from '@components/layout/Header';
import Footer from '@components/layout/Footer';
import MansionNavigation from '@components/MansionNavigation';
import Breadcrumbs from '@components/common/Breadcrumbs';
import MansionPopular from '@components/MansionPopular';
import MansionNavigationProps from '@/types/components/MansionNavigation/MansionNavigationProps';
import App from './app';

const targetId = 'app-content-cities';

// Section for render component ----------------------------------------------------------------------------------------

function CitiesTopComment() {
  const container = document.getElementById('app-content-cities-top-content')!;
  container.style.display = 'block';
  // load blade html element
  const reactElement = parse(container.innerHTML);
  return (
    <Box className="md:mx-24 mt-16 mb-10 max-md:w-[calc(100%_-_40px)] max-sm:mt-2 max-sm:mb-8 max-md:mx-5">
      {reactElement}
    </Box>
  );
}

// Render component if the targetId element exists in the DOM.
if (document.getElementById(targetId)) {
  const container = document.getElementById(targetId)!;
  const root = createRoot(container);

  const { props } = container.dataset;
  const propsData: MansionNavigationProps = JSON.parse(props!);
  const { isPrefectureSelect } = propsData;
  const { selectedPrefecture } = propsData;
  const { isCitySelect } = propsData;
  const { selectedCity } = propsData;
  const { typeNavigation } = propsData;
  const breadcrumbs = container.dataset.breadcrumbs ? JSON.parse(container.dataset.breadcrumbs) : [];
  const title =
    selectedPrefecture && 'pref_name' in selectedPrefecture
      ? `${selectedPrefecture.pref_name}の人気のマンション`
      : false;
  const prefCodeName =
    selectedPrefecture && 'pref_code_name' in selectedPrefecture ? selectedPrefecture.pref_code_name : false;
  root.render(
    <App>
      <Header />
      <CitiesTopComment />
      <Box>
        <MansionNavigation
          isPrefectureSelect={isPrefectureSelect}
          selectedPrefecture={selectedPrefecture}
          isCitySelect={isCitySelect}
          selectedCity={selectedCity}
          typeNavigation={typeNavigation}
          isLineSelect={false}
          selectedLine={null}
          mansionsData={null}
          navigationName="cities"
        />
      </Box>
      <MansionPopular limit={40} title={title} prefecture={prefCodeName} />
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <Footer />
    </App>,
  );
}
